module.exports = __webpack_public_path__ + "static/media/use-hd.647bbdf0.png";